import service from '@/services';
import type { SlackNotificationT } from '@/services/integrations/slack_webhook/types';
import { getSlackWebhookUrl } from '@/utils/integration';

export const getSlackWebhookItems = async (
  workspaceAlias: string,
): Promise<SlackNotificationT[]> => {
  return await service.slackWebhook.fetchSlackWebhookInfos(workspaceAlias);
};

export const connectSlackWebhook = async (workspaceAlias: string) => {
  const url = getSlackWebhookUrl(workspaceAlias);
  window.open(url);
};
